module.exports = __webpack_public_path__ + "img/golfpractice_bodyimage02.3160af0e.jpg";